module.exports = __webpack_public_path__ + "img/nritana-edutainment-for-student.7a99a4bd.jpg";